import { take, fork, select, put, call } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { callApi } from "./callApi";
import { successClubTables, failClubTables, successCreateTable } from "../actionCreators/table";
import config from "../../config/config";
import { getCurrentClubId, getGlobalClub, getClubList, getCurrentClubPlayerId } from "../selectors";
import {showNotification} from "../actionCreators/notification";
import parameters from "../../config/parameters";

function* getClubTables() {
    const clubList = yield select(getClubList);
    const skinArray = clubList.map(clb => clb.clubId).join(',');
    try {
        const response = yield call(callApi, `${config.BO_API_URL}/skin/tables`, 'GET', { skinArray });
        yield put(successClubTables(response.data.result));
    } catch (e) {
        yield put(failClubTables({ loginError: e }));
    }
}

function* createTable({ params, history }) {
    try {
        const clubId = yield select(getCurrentClubId);
        const accountId = yield select(getCurrentClubPlayerId);
        const bb = parameters.smallBlinds[params.smallBlind] * 200;
        const durationValues = [ 24, 24*7, 24*30 ];
        const tableParams = {
            ...params,
            clubId,
            accountId,
            duration: durationValues[params.duration],
            rake: parseInt(params.fee.value),
            cap: params.cap.value,
            smallBlind: bb / 2,
            bigBlind: bb,
            minBuyIn: params.buyin[0] * bb,
            maxBuyIn: params.buyin[1] * bb
        };
        console.log('createTable: params: ', tableParams);

        yield call(callApi, `${config.BO_API_URL}/clubtables/`, 'POST', tableParams);
        yield put(successCreateTable());
        yield history.push(`/club/${clubId}`);
        yield put(showNotification({message: `Successfully created the table`}));

    } catch (e) {}
}

export function* watchClubTables() {
    while (true) {
        yield take([actionTypes.REQUEST_CLUB_TABLES, actionTypes.CREATE_TABLE_SUCCESS, actionTypes.CLUBS_SUCCESS]);
        yield fork(getClubTables);
    }
}

export function* watchCreateTable() {
    while (true) {
        const action = yield take(actionTypes.CREATE_TABLE_REQUEST);
        yield fork(createTable, action);
    }
}
